// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgx_a bie_vt bie_ea bie_a","MenuItem__Btn":"bgx_b bie_z","MenuItem__subtitle":"bgx_c"};